import { getGameMetrics } from 'src/games/phaserblocks/logic/helpers/game-metrics';
import { GameServices } from '../../services/game-services';
import { LoadingCellViewModel } from './loading-cell-view-model';
import { BehaviorSubject } from 'rxjs';

export class LoadingGridViewModel {
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onGameSetupStart$() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get showLoadingGrid$() {
    return this.showLoadingGrid.asObservable();
  }
  public get allLoadingCellViewModels() {
    return this.loadingCellViewModels;
  }

  private loadingCellViewModels: LoadingCellViewModel[] = [];

  private readonly showLoadingGrid = new BehaviorSubject<boolean>(true);

  constructor(private gameServices: GameServices) {
    const logicVersion = gameServices.gameRunnerService.currentGame?.logicVersion ?? 1;
    const gameMetrics = getGameMetrics(logicVersion);

    for (let row = 0; row < gameMetrics.GridSize; ++row) {
      for (let column = 0; column < gameMetrics.GridSize; ++column) {
        this.loadingCellViewModels.push(new LoadingCellViewModel(gameServices, row, column));
      }
    }
  }

  public onGameSetupStart() {
    this.showLoadingGrid.next(false);
  }

  public resetGameScene() {
    this.showLoadingGrid.next(true);
  }
}
